/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-did-update-set-state  */
import PropTypes from 'prop-types';
import {stringToDashed} from 'cl-automation-utils';
import React, {PureComponent} from 'react';
import Paper from 'material-ui/Paper';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import TextField from 'material-ui/TextField';
import ChildrenFader from 'shared/components/ChildrenFader';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import DropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import Popover from '@material-ui/core/Popover';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {findDOMNode} from 'react-dom';
import AutoComplete from 'material-ui/AutoComplete';
import {Tabs, Tab} from 'material-ui/Tabs';
import MuiThemeUpdater from 'shared/utils/MuiThemeUpdater';
const searchQuery = require('search-query-parser');
const SEARCH_QUERY_TEXT_FIELD = 'searchQueryTextField';

const TABS = {
  SEARCH: 0,
  FIND_AND_REPLACE: 1,
};

export const styles = {};

export default class SearchField extends PureComponent {
  state = {
    value: this.props.complex ? {} : '',
    focus: false,
    popoverOpened: false,
    tabValue: TABS.SEARCH,
  };

  componentWillMount() {
    const {defaultValue} = this.props;
    this.setState({value: this.getParsedValue(defaultValue)});
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (!this.state.popoverOpened && nextState.popoverOpened) {
      this.setState({popoverContentHeight: undefined});
    }

    if (this.props.value !== nextProps.value && nextProps !== nextState.value) {
      this.setState({value: nextProps.value});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {popoverOpened, tabValue} = this.state;
    if (
      (!prevState.popoverOpened && popoverOpened) ||
      (tabValue === TABS.SEARCH && prevState.tabValue !== TABS.SEARCH)
    ) {
      _.defer(() => {
        this.focus(this.toFocus);
      });
    }
    if (!prevState.popoverOpened && popoverOpened) {
      _.defer(() => {
        this.setState({popoverContentHeight: this.refs.popoverContent.scrollHeight});
      });
    }
  }

  onKeyDown = event => {
    const {onEnterDown} = this.props;
    const {value} = this.state;
    if (event.key === 'Enter') {
      if (_.isFunction(onEnterDown)) {
        onEnterDown(value);
      } else {
        this.handleSearch();
      }
    }
    if (event.key === 'Escape') {
      this.closePopover();
    }
  };

  getParsedValue = value => {
    value = value ? value : this.state.value;
    if (_.isString(value)) {
      return value;
    }
    const text = _.get(value, 'text');
    let parsedValue = '';
    let any = '';
    _.forEach(value, (field, key) => {
      if (key !== '') {
        parsedValue = parsedValue + key + ':' + this.addApostrophesIfNeeded(field) + ' ';
      } else {
        any = field;
      }
    });
    return parsedValue + any;
  };

  reset = () => {
    this.setState({value: this.props.complex ? {} : ''});
  };

  toFocus =
    this.props.complex &&
    _.find(this.props.filterFields, filterField => {
      return filterField.label;
    }).label;

  addApostrophesIfNeeded = value => {
    const exactMatch =
      _.isString(value) && value.length >= 2 && value.charAt(0) === '"' && value.charAt(value.length - 1) === '"';
    if (exactMatch) {
      return `'${value}'`;
    }
    if (_.isString(value) && value.indexOf(' ') !== -1) {
      return '"' + value + '"';
    }
    return value;
  };

  handleReset = () => {
    this.setState({value: ''});
  };

  handleSearch = () => {
    const {value} = this.state;
    this.closePopover();
    this.debouncedUpdate(value);
  };

  openPopover = () => {
    const {filterFields} = this.props;
    const {value} = this.state;
    let parsedString = '';
    if (_.isString(value) && !_.isEmpty(value)) {
      parsedString = searchQuery.parse(value, {keywords: _.keys(_.omit(filterFields, 'text'))});
      if (_.isString(parsedString)) {
        parsedString = {'': parsedString};
      } else {
        parsedString[''] = _.get(parsedString, 'text') ? _.get(parsedString, 'text') : '';
      }
    }
    this.setState({
      popoverOpened: true,
      value: parsedString ? _.omit(_.pick(parsedString, _.concat(_.keys(filterFields), '')), 'text') : value,
      tabValue: TABS.SEARCH,
    });
  };

  closePopover = () => {
    this.setState({
      popoverOpened: false,
      focus: false,
    });
  };

  displayToFieldNameKeys = filter => {
    const {filterFields} = this.props;
    if (_.isString(filter)) {
      return filter;
    }
    return _.mapKeys(filter, (value, key) => {
      const newKey = _.get(filterFields[key], 'fieldName');
      return newKey ? newKey : key;
    });
  };

  debouncedUpdate = _.debounce(value => {
    const {onChange, filterFields} = this.props;
    if (onChange) {
      onChange(
        this.displayToFieldNameKeys(
          searchQuery.parse(this.getParsedValue(value), {keywords: _.keys(_.omit(filterFields, 'text'))})
        )
      );
    }
  }, 150);

  updateValue = value => {
    this.setState({value});
  };

  handleChange = value => {
    this.debouncedUpdate(value);
    this.setState({value});
  };

  handleFilterChange = (filterField, newValue) => {
    const {value} = this.state;
    if (_.isObject(value)) {
      value[filterField] = newValue;
      this.setState({value: _.assign({}, value)});
    } else {
      this.setState({value: {[filterField]: newValue}});
    }
  };

  handleFocus = () => {
    this.setState({focus: true});
  };

  handleBlur = () => {
    this.setState({focus: false});
  };

  focus = target => {
    _.get(this.refs, target).focus();
  };

  handleTabChange = tabValue => {
    this.setState({tabValue});
  };

  stopPropagation = event => {
    event.stopPropagation();
  };

  renderTextField(filterField) {
    const {value} = this.state;
    const displayValue = (_.isObject(value) && value[_.get(filterField, 'display')]) || '';
    return (
      filterField.label && (
        <TextField
          id={`cla-field-search-by-${stringToDashed(filterField.label.toLowerCase())}`}
          key={filterField.label}
          fullWidth
          hintText={filterField.hint}
          floatingLabelText={filterField.label}
          value={displayValue}
          onChange={(event, newValue) => this.handleFilterChange(filterField.display, newValue)}
          onKeyDown={this.onKeyDown}
          ref={filterField.label}
          tabIndex={1}
        />
      )
    );
  }

  renderSearchPopoverContent() {
    const {filterFields} = this.props;
    return (
      <div style={{padding: 20}} ref="popoverContent">
        {_.map(_.omit(filterFields, 'text'), filterField => {
          return this.renderTextField(filterField);
        })}
        {this.renderTextField(filterFields.text)}
        <div style={{height: 60}} />
        <div style={{display: 'flex', justifyContent: 'flex-end', paddingTop: 20}}>
          <FlatButton
            id="cla-btn-reset"
            label="reset"
            onClick={this.handleReset}
            style={{marginRight: 20}}
            tabIndex={3}
          />
          <RaisedButton id="cla-btn-search" label="search" onClick={this.handleSearch} primary tabIndex={2} />
        </div>
      </div>
    );
  }

  renderPopoverContent() {
    const {popoverContentHeight, tabValue} = this.state;
    const {findAndReplaceTabProps} = this.props;
    const search = this.renderSearchPopoverContent();
    const FindAndReplaceElement = this.props.findAndReplaceElement;
    let content;
    if (FindAndReplaceElement) {
      content = (
        <div key="content">
          <div style={{display: 'flex', justifyContent: 'center', backgroundColor: Colors.grey300}}>
            <MuiThemeUpdater
              themeUpdate={{tabs: {textColor: {$set: Colors.grey500}, selectedTextColor: {$set: Colors.grey800}}}}
            >
              <Tabs
                value={tabValue}
                onChange={this.handleTabChange}
                style={{width: '70%'}}
                tabItemContainerStyle={{backgroundColor: Colors.transparent}}
              >
                <Tab id="cla-tab-search" label="search" value={TABS.SEARCH} />
                <Tab
                  id="cla-tab-find-and-replace"
                  label="find & replace"
                  value={TABS.FIND_AND_REPLACE}
                  {...findAndReplaceTabProps}
                />
              </Tabs>
            </MuiThemeUpdater>
          </div>
          <div style={{display: tabValue !== TABS.SEARCH ? 'none' : undefined}}>{search}</div>
          <FindAndReplaceElement
            open={tabValue === TABS.FIND_AND_REPLACE}
            style={{
              display: tabValue !== TABS.FIND_AND_REPLACE ? 'none' : 'flex',
              boxSizing: 'border-box',
              height: popoverContentHeight,
              padding: 20,
              flexDirection: 'column',
              position: 'relative',
            }}
            onRequestClose={this.closePopover}
          />
        </div>
      );
    } else {
      content = search;
    }
    return [
      content,
      <IconButton
        id="cla-close"
        key="iconButton"
        style={{position: 'absolute', right: 0, top: 0}}
        onClick={this.closePopover}
        tabIndex={4}
      >
        <CloseIcon />
      </IconButton>,
    ];
  }

  render() {
    const {
      onEnterDown,
      findAndReplaceTabProps,
      hintText,
      onChange,
      complex,
      style,
      dataSource,
      findAndReplaceElement,
      filterFields,
      minified,
      id,
      ...props
    } = this.props;
    const {value, focus, popoverOpened, anchorEl} = this.state;
    const parsedValue = complex ? this.getParsedValue() : value;
    const ICON_SIZE = 24;
    const showMinified = minified && (!focus && _.isEmpty(value));
    return (
      <Paper
        key={1}
        style={{
          height: 45,
          backgroundColor: showMinified ? Colors.transparent : focus ? Colors.white : Colors.grey200,
          display: 'flex',
          alignItems: 'center',
          marginLeft: 20,
          transitionDuration: 250,
          position: 'relative',
          width: '100%',
          maxWidth: showMinified ? ICON_SIZE * 2 : 500,
          ...style,
        }}
        zDepth={focus ? 1 : 0}
        onClick={() => this.focus(SEARCH_QUERY_TEXT_FIELD)}
        {...props}
      >
        <IconButton
          className="cla-search-icon"
          disabled={!showMinified}
          style={{
            flexShrink: 0,
          }}
        >
          <SearchIcon
            style={{
              height: ICON_SIZE,
              width: ICON_SIZE,
              transform: focus && !minified ? undefined : 'translate3d(-1px, 1px, 0)',
              transitionDuration: 250,
            }}
          />
        </IconButton>
        <AutoComplete
          id={`${id}-input`}
          fullWidth
          popoverProps={{style: {width: 300, overflow: 'hidden', transform: 'translateX(50px)'}}}
          filter={AutoComplete.caseInsensitiveFilter}
          style={{
            height: '100%',
            width: 0,
            overflow: 'hidden',
            flexGrow: 1,
          }}
          underlineStyle={{display: 'none'}}
          hintText={hintText}
          onUpdateInput={_.isEmpty(dataSource) ? this.handleChange : this.updateValue}
          onNewRequest={this.handleChange}
          searchText={parsedValue}
          onFocus={() => this.handleFocus()}
          onBlur={this.handleBlur}
          ref={SEARCH_QUERY_TEXT_FIELD}
          onKeyDown={this.onKeyDown}
          dataSource={dataSource || []}
          maxSearchResults={10}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          hintStyle={{whiteSpace: 'nowrap'}}
        />
        <ChildrenFader
          style={{
            width: ICON_SIZE * 2,
          }}
          visible={!_.isEmpty(value)}
          hideDelayMs={150}
        >
          <IconButton onClick={this.handleChange.bind(this, '')}>
            <CloseIcon />
          </IconButton>
        </ChildrenFader>
        {complex && [
          <IconButton
            id="cla-advanced-search"
            key={1}
            ref={ref => {
              if (ref) {
                this.setState({anchorEl: findDOMNode(ref)});
              }
            }}
            onClick={this.openPopover}
            style={{marginLeft: -16}}
          >
            <DropDownIcon />
          </IconButton>,
          <Popover
            key={2}
            anchorEl={anchorEl}
            PaperProps={{
              style: {
                width: 500,
              },
            }}
            open={popoverOpened}
            onClose={this.closePopover}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            transformOrigin={{horizontal: 'right', vertical: 'top'}}
            onClick={this.stopPropagation}
          >
            <div>{this.renderPopoverContent()}</div>
          </Popover>,
        ]}
      </Paper>
    );
  }
}

SearchField.propTypes = {
  hintText: PropTypes.string,
  onChange: PropTypes.func,
  complex: PropTypes.bool,
  filterFields: PropTypes.object,
  findAndReplaceElement: PropTypes.func,
  findAndReplaceTabProps: PropTypes.object,
  minified: PropTypes.bool,
};
